import moment from "moment";

export const getToken = () => {
  return sessionStorage.getItem("token");
};

export const getUserID = () => {
  return sessionStorage.getItem("id");
};

export const getMomentFormatDateTime = (value) => {
  return value !== ""
    ? moment(value)
    : moment().format("YYYY-MM-DD HH:mm:ss").replace(" ", "T") + "Z";
};

export const getMomentFormatDate = (value) => {
  return value !== ""
    ? moment(value).format("YYYY-MM-DD")
    : moment().format("YYYY-MM-DD");
};

export const checkError = (error) => {
  console.log("error of auth");
  switch (error) {
    case "EXPIRED":
      return "/dashboard/home/invalidAccess";
    case "Error:undefined":
      sessionStorage.removeItem("token");
      return "/";
    default:
      return "*";
  }
};

export const getVideoId = (url) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.searchParams.get("v");
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
};
